import { environmentInfo } from '@ms-cloudpack/environment';
import fs from 'fs';
import path from 'path';

export function getOpensslPath(): string {
  const openSslFilename = environmentInfo.windows ? 'openssl.exe' : 'openssl';
  const defaultOpenSslPath = environmentInfo.windows
    ? path.join(environmentInfo.windows?.programFiles ?? '', 'git', 'mingw64', 'bin')
    : path.join('/', 'usr', 'bin');
  const defaultOpenSslFilePath = path.join(defaultOpenSslPath, openSslFilename);

  if (!fs.existsSync(defaultOpenSslFilePath)) {
    throw Error(`\nCould not find openssl in path: "${defaultOpenSslPath}"\n`);
  }

  return defaultOpenSslFilePath;
}
